import { ContainerModule } from "inversify";
import {
  ICadastrarVoucherGateway,
  cadastrarVoucherGatewayDI
} from "../ports/CadastrarVoucherGateway";
import { CadastrarVoucherGatewayAdapter } from "../Adapter/CadastrarVoucherGatewayAdapter";
import {
  ICadastrarVoucherUsecase,
  cadastrarVoucherUsecaseDI
} from "../ports/CadastrarVoucherUseCase";
import CadastrarVoucherUseCaseAdapter from "../Adapter/CadastrarVoucherUsecaseAdapter";
import {
  IBuscarVoucherUseCase,
  buscarVoucherUseCaseDI
} from "../ports/ListarVoucherUsecase";
import {
  IListarVoucherGateway,
  listarVoucherGatewayDI
} from "../ports/ListarVoucherGateway";
import { ListarVoucherUsecaseAdapter } from "../Adapter/ListarVoucherUsecaseAdapter";
import { ListarVoucherGatewayAdapter } from "../Adapter/ListarVoucherGatewayAdapter";
import {
  IIniciarVoucherGateway,
  iniciarVoucherGatewayDI
} from "../ports/IniciarVoucherGateway";
import { IniciarVoucherGatewayAdapter } from "../Adapter/IniciarVoucherGatewayAdapter";
import {
  IIniciarVoucherUseCase,
  iniciarVoucherUseCaseDI
} from "../ports/IniciarVoucherUsecase";
import { IniciarVoucherUsecaseAdapter } from "../Adapter/IniciarVoucherUsecaseAdapter";
import {
  IDesativarVoucherGateway,
  desativarVoucherGatewayDI
} from "../ports/DesativarVoucherGateway";
import { DesativarVoucherUseCaseAdapter } from "../Adapter/DesativarVoucherUseCaseAdapter";
import {
  IDesativarVoucherUseCase,
  desativarVoucherUseCaseDI
} from "../ports/DesativarVoucherUseCase";
import { DesativarVoucherGatewayAdapter } from "../Adapter/DesativarVoucherGatewayAdapter";

const voucherContainer = new ContainerModule((bind) => {
  bind<ICadastrarVoucherGateway>(cadastrarVoucherGatewayDI).to(
    CadastrarVoucherGatewayAdapter
  );
  bind<ICadastrarVoucherUsecase>(cadastrarVoucherUsecaseDI).to(
    CadastrarVoucherUseCaseAdapter
  );
  bind<IListarVoucherGateway>(listarVoucherGatewayDI).to(
    ListarVoucherGatewayAdapter
  );
  bind<IBuscarVoucherUseCase>(buscarVoucherUseCaseDI).to(
    ListarVoucherUsecaseAdapter
  );
  bind<IIniciarVoucherGateway>(iniciarVoucherGatewayDI).to(
    IniciarVoucherGatewayAdapter
  );
  bind<IIniciarVoucherUseCase>(iniciarVoucherUseCaseDI).to(
    IniciarVoucherUsecaseAdapter
  );
  bind<IDesativarVoucherGateway>(desativarVoucherGatewayDI).to(
    DesativarVoucherGatewayAdapter
  );
  bind<IDesativarVoucherUseCase>(desativarVoucherUseCaseDI).to(
    DesativarVoucherUseCaseAdapter
  );
});

export { voucherContainer };
